import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ButtonShape, ButtonSize, IconName, ProductGrid, ProductTypes } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { LazyLoadOptions, LISTER_TILES_ID, } from '@as-react/common-types';
import { Box, Pagination, StackBlock } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { WISHLIST_COMPONENT } from '../../constants/DOMElementsConstants';
import { PLACEHOLDER_TILES, FASCIA_AND_MAIN_WEB_SHOP } from '../../constants/GeneralConstants';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { ProductAddToBasketLocations } from '../../enums/ActionEnums';
import { basketActions } from '../../redux/basket/actions/BasketActions.creators';
import compareActions from '../../redux/compare/actions/CompareActions.creators';
import { makeGetCompareItems } from '../../redux/compare/selectors/CompareSelectors';
import { makeGetQueryParamPage } from '../../redux/router/selectors/RouterSelector';
import { wishListActions } from '../../redux/wishList/actions/WishListActions.creators';
import { makeGetWishlistTotalPages } from '../../redux/wishList/selectors/WishListSelectors';
import { isClickAndCollectOnly, isExtensiveProductTile, isInStoreOnly, isProductOutOfStock, } from '../../util/ProductUtil';
import { ScrollUtil } from '../../util/ScrollUtil';
import { ProductTileVertical } from '../product-tile/vertical/ProductTileVertical';
export const WishlistLister = ({ items, onWishlistToggle, setMiniPDPProduct, productTileFormat, deliveryPromiseExplanations, }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation([I18N_NAMESPACES.general, I18N_NAMESPACES.product]);
    const { canonicalUrl, mainWebShop, root, isShopLanding, feature_toggles: { lowest_price_all }, } = useAemConfig();
    const compareItems = useSelector(makeGetCompareItems());
    const totalPages = useSelector(makeGetWishlistTotalPages());
    const currentPage = useSelector(makeGetQueryParamPage());
    const handleAddToBasket = (product) => {
        dispatch(basketActions.createAddExtensiveTileProductAction(product, ProductAddToBasketLocations.WISHLIST));
    };
    const getDeliveryPromise = (payload) => dispatch(wishListActions.getDeliveryPromise(Object.assign({}, payload)));
    const determineLazyLoadState = (index) => {
        const amountNonLazyLoadedTiles = PLACEHOLDER_TILES.length;
        switch (true) {
            case index < amountNonLazyLoadedTiles:
                return LazyLoadOptions.NO_LAZY_LOAD;
            case index < amountNonLazyLoadedTiles * 1.5:
                return LazyLoadOptions.LAZY_PRE_LOAD;
            default:
                return LazyLoadOptions.LAZY_LOAD;
        }
    };
    const handleUpdateCompare = (product) => {
        dispatch(compareActions.createUpdateOnProductDetailPageAction(product));
    };
    const handleOutOfStockClick = (item) => (event) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        window.location.href = `${root}c${item.category.relativeUrl}.html`;
    };
    const onPageChangeHandler = (newPage) => {
        dispatch(wishListActions.updateWishListPage({ page: newPage }));
        ScrollUtil.scrollToElement(document.querySelector(WISHLIST_COMPONENT));
    };
    return (_jsxs(_Fragment, { children: [_jsx(ProductGrid, { analyticsAreaName: LISTER_TILES_ID, showExtraDesktopColumn: true, children: items.map((item, index) => {
                    var _a, _b;
                    const shouldLazyLoadImage = determineLazyLoadState(index);
                    const productOutOfStock = isProductOutOfStock(item);
                    const handleTileClick = (e) => {
                        const isNotBever = mainWebShop !== FASCIA_AND_MAIN_WEB_SHOP['1_BEVER'];
                        const isPaperVoucher = [
                            ProductTypes.PAPER_VOUCHER,
                            ProductTypes.CUSTOM_PAPER_VOUCHER,
                            ProductTypes.GIFT_CARD,
                            ProductTypes.CUSTOM_GIFT_CARD,
                        ].includes(item.type);
                        const isEVoucher = item.type === ProductTypes.E_VOUCHER;
                        if (isEVoucher || (isPaperVoucher && isNotBever) || productOutOfStock) {
                            return;
                        }
                        e.preventDefault();
                        e.stopPropagation();
                        setMiniPDPProduct(item);
                    };
                    return (_jsx(ProductTileVertical, { product: item, format: productTileFormat, onTileClick: isExtensiveProductTile(productTileFormat) ? undefined : handleTileClick, onWishListToggle: onWishlistToggle, updateCompareList: handleUpdateCompare, compareItems: compareItems, shouldLazyLoadImage: shouldLazyLoadImage, alwaysShowSwatches: isShopLanding, addToBasket: handleAddToBasket, showComparison: true, showSwatchesOnHover: false, showProductOutOfStockOverlay: true, showColorOutOfStockOverlay: true, outOfStockActions: productOutOfStock &&
                            item.active &&
                            ((_a = item.category) === null || _a === void 0 ? void 0 : _a.active) && (_jsx(Button, { size: ButtonSize.XSMALL, shape: ButtonShape.PILL, onClick: handleOutOfStockClick(item), text: t('general:wishlist.outOfStock.suggestions') })), iconName: productOutOfStock ? IconName.CLOSE : undefined, outOfStockMessage: productOutOfStock && !item.active ? t('product:product.definitivelyOutOfStock') : undefined, inWishLister: true, dropdownProps: { appendToBody: true }, showCompareForExtensiveTile: true, inStoreOnly: isInStoreOnly(item), clickAndCollectOnly: isClickAndCollectOnly(item), getDeliveryPromise: getDeliveryPromise, deliveryPromiseExplanations: deliveryPromiseExplanations, defaultSize: (_b = item.sku) === null || _b === void 0 ? void 0 : _b.toString(), enablePriceReference: lowest_price_all }, `${item.productCode}${item.colourId}${index}`));
                }) }), totalPages > 1 && (_jsx(Box, { paddingBlockStart: "8", children: _jsx(StackBlock, { itemsAlign: "center", children: _jsx(Pagination, { baseUrl: canonicalUrl, currentPage: currentPage, onPageChange: onPageChangeHandler, totalPages: totalPages }) }) }))] }));
};
